const isMcom = import.meta.env.VITE_ENTRY_POINT === 'mcom';
const assetHost = process.env.ASSET_HOST || import.meta.env.ASSET_HOST || '';

const mcomLinks = [
  { rel: 'preconnect', href: 'https://slimages.macysassets.com' },
  { rel: 'preconnect', href: assetHost, crossorigin: '' },
  { rel: 'preconnect', href: 'https://tags.tiqcdn.com' },
  {
    rel: 'preload',
    href: 'https://assets.macysassets.com/common/assets/fonts/macys-sans/MacysSans.woff2',
    as: 'font',
    type: 'font/woff2',
    crossorigin: 'anonymous',
  },
  {
    rel: 'preload',
    href: 'https://assets.macysassets.com/common/assets/fonts/macys-sans/MacysSansMd.woff2',
    as: 'font',
    type: 'font/woff2',
    crossorigin: 'anonymous',
  },
  {
    rel: 'preload',
    href: 'https://assets.macysassets.com/common/assets/fonts/macys-sans/MacysSansBd.woff2',
    as: 'font',
    type: 'font/woff2',
    crossorigin: 'anonymous',
  },
];

const bcomLinks = [
  { rel: 'preconnect', href: 'https://images.bloomingdalesassets.com' },
  { rel: 'preconnect', href: assetHost, crossorigin: '' },
  { rel: 'preconnect', href: 'https://tags.tiqcdn.com' },
];

export const headLinks = isMcom ? mcomLinks : bcomLinks;
